"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormulaComposition = exports.inspectDependencies = void 0;
const excelFormulaParser = __importStar(require("excel-formula-parser"));
const rangeVariables_1 = require("./rangeVariables");
// for each function referenced it also should return number of parameters passed.
const inspectDependencies = (formula) => {
    const tree = excelFormulaParser.parse(formula);
    // this will hold a set of variables referenced in formula.
    const variables = new Set();
    // this map will hold functions referenced in formula.
    //   for each function - it will maintain an array of numbers corresponding
    //   to the number of parameters passed for each instances of the function call.
    // For example: formula "SUM(SUM(1), FLOOR(1,2))"
    //  will yield map entries "SUM" => [2, 1], "FLOOR" => [2]
    const functionToArgCounts = new Map();
    excelFormulaParser.visit(tree, {
        enterCell: ({ key }) => {
            variables.add(key);
        },
        enterFunction: (input) => {
            const argCounts = functionToArgCounts.get(input.name) || [];
            argCounts.push(input.arguments.length);
            functionToArgCounts.set(input.name, argCounts);
        },
    });
    return {
        variables,
        functionToArgCounts,
    };
};
exports.inspectDependencies = inspectDependencies;
const getFormulaComposition = (formula) => {
    const tree = excelFormulaParser.parse(formula);
    const numberValues = [];
    const textValues = [];
    const nonRangeVariables = [];
    const rangeVariables = [];
    const functions = [];
    excelFormulaParser.visit(tree, {
        enterNumber: ({ value }) => {
            numberValues.push(value);
        },
        enterText: ({ value }) => {
            textValues.push(value);
        },
        enterCell: ({ key }) => {
            if ((0, rangeVariables_1.isRangeVariable)(key)) {
                rangeVariables.push(key);
            }
            else {
                nonRangeVariables.push(key);
            }
        },
        enterFunction: ({ name }) => {
            functions.push(name);
        },
    });
    return {
        numberValues,
        textValues,
        nonRangeVariables,
        rangeVariables,
        functions,
    };
};
exports.getFormulaComposition = getFormulaComposition;
//# sourceMappingURL=inspectDependencies.js.map